import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PEV } from "../../../common/utils";
import * as service from "./service";

export const InputApiConstants = {
  Offices: "offices",
  JobProfiles: "jobProfiles",
  Departments: "departments",
  POHs: "poh",
  Miscellaneous: "miscellaneous"
};

export const InputFieldApiNotLoaded = "Not Loaded";

const initialState = {
  [InputApiConstants.Offices]: PEV([], InputFieldApiNotLoaded),
  [InputApiConstants.JobProfiles]: PEV([], InputFieldApiNotLoaded),
  [InputApiConstants.Departments]: PEV([], InputFieldApiNotLoaded),
  [InputApiConstants.POHs]: PEV([], InputFieldApiNotLoaded),
  [InputApiConstants.Miscellaneous]: PEV([], InputFieldApiNotLoaded),
};

function asyncThunkCreation(inputApiConstant, serviceFunction) {
  return createAsyncThunk(`${inputApiConstant}/get`, async () => {
    return await serviceFunction();
  });
}

const getOffices = asyncThunkCreation(InputApiConstants.Offices, service.getOffices);
const getDepartments = asyncThunkCreation(InputApiConstants.Departments, service.getDepartments);
const getJobProfiles = asyncThunkCreation(InputApiConstants.JobProfiles, service.getJobProfiles);
const getPOHs = asyncThunkCreation(InputApiConstants.POHs, service.getPOHs);
const getMiscellaneous = asyncThunkCreation(InputApiConstants.Miscellaneous, service.getMiscellaneous);

function pendingApiCall(state, attribute) {
  state[attribute] = PEV(state[attribute].value, `Fetching ${attribute} input value`);
}

function fulfilledApiCall(action, state, attribute) {
  let response = action.payload;
  state[attribute] = PEV(response);
}

function rejectedApiCall(state, attribute) {
  state[attribute] = PEV(
    state[attribute].value,
    null,
    `Error while fetching ${attribute} input value`
  );
}

const InputFieldsSlice = createSlice({
  name: "input-fields",
  initialState,
  reducers: {},
  extraReducers: {
    [getOffices.pending.type]: (state) => {
      pendingApiCall(state, InputApiConstants.Offices);
    },
    [getOffices.fulfilled.type]: (state, action) => {
      fulfilledApiCall(action, state, InputApiConstants.Offices);
    },
    [getOffices.rejected.type]: (state) => {
      rejectedApiCall(state, InputApiConstants.Offices);
    },
    [getDepartments.pending.type]: (state) => {
      pendingApiCall(state, InputApiConstants.Departments);
    },
    [getDepartments.fulfilled.type]: (state, action) => {
      fulfilledApiCall(action, state, InputApiConstants.Departments);
    },
    [getDepartments.rejected.type]: (state) => {
      rejectedApiCall(state, InputApiConstants.Departments);
    },
    [getJobProfiles.pending.type]: (state) => {
      pendingApiCall(state, InputApiConstants.JobProfiles);
    },
    [getJobProfiles.fulfilled.type]: (state, action) => {
      fulfilledApiCall(action, state, InputApiConstants.JobProfiles);
    },
    [getJobProfiles.rejected.type]: (state) => {
      rejectedApiCall(state, InputApiConstants.JobProfiles);
    },
    [getPOHs.pending.type]: (state) => {
      pendingApiCall(state, InputApiConstants.POHs);
    },
    [getPOHs.fulfilled.type]: (state, action) => {
      fulfilledApiCall(action, state, InputApiConstants.POHs);
    },
    [getPOHs.rejected.type]: (state) => {
      rejectedApiCall(state, InputApiConstants.POHs);
    },
    [getMiscellaneous.pending.type]: (state) => {
      pendingApiCall(state, InputApiConstants.Miscellaneous);
    },
    [getMiscellaneous.fulfilled.type]: (state, action) => {
      fulfilledApiCall(action, state, InputApiConstants.Miscellaneous);
    },
    [getMiscellaneous.rejected.type]: (state) => {
      rejectedApiCall(state, InputApiConstants.Miscellaneous);
    },
  },
});

export const InputFieldsActions = { getDepartments, getJobProfiles, getOffices, getPOHs, getMiscellaneous };

export const InputFieldsReducer = InputFieldsSlice.reducer;
